import { EventEmitter } from 'events';
import { tmpl } from '@/utils/util-extent';

const { $ } = window;

export default class TestDriveRecord extends EventEmitter {
  constructor($container, data, tel, email) {
    super();
    this.loading = false;
    this.data = data;
    this.tel = tel;
    this.email = email;

    this.$target = $(tmpl($('#template-testdrive-record').html(), data));
    // const itemTmpl = $('#template-testdrive-record-item').html();
    // const $items = this.$target.find('.items');
    // Object.keys(data.DATA).forEach((key) => {
    //   $items.append($(tmpl(itemTmpl, data.DATA[key])));
    // });
    const $cancelBtn = this.$target.find('.result-action, .result-actions');
    if (data.CNACELABLE && data.CNACELABLE === 'Y') {
      $cancelBtn.on('click', this.onCancelClick.bind(this));
    } else {
      $cancelBtn.find('a').hide();
    }
    const ishide = data.TYPE==='2';
      if (ishide) {
        this.$target.find(".testdrive-expect-date").hide();
        this.$target.find(".testdrive-actual-date").hide();
      } else {
        this.$target.find(".testdrive-expect-date").show();
        this.$target.find(".testdrive-actual-date").show();
      }
    $container.append(this.$target);
  }

  onCancelClick() {
    // eslint-disable-next-line no-restricted-globals
    if (confirm('確定要取消預約嗎？')) {
      if (this.loading) return;
      this.loading = true;
      // gaev('btn', 'click', 'btn_testdrive_cancel');
      $.ajax({
        url: 'api/testdrive_cancel.ashx',
        type: 'POST',
        dataType: 'json',
        cache: 'false',
        data: {
          ID: this.data.ID,
          TEL: this.tel,
          EMAIL: this.email,
        },
      })
        .done((e) => {
          if (e.RS === 'OK') {
            this.$target.remove();
            alert('已取消預約！');
            this.emit(TestDriveRecord.CANCEL);
          } else {
            alert(e.RS);
          }
        })
        .fail((e) => {
          console.log('error', e);
        })
        .always(() => {
          this.loading = false;
        });
    }
  }
}
TestDriveRecord.CANCEL = 'TestDriveRecord.Cancel';
